// extracted by mini-css-extract-plugin
module.exports = {"container":"dashboard_container__2EHlg"};